<script>
export default {
    props: [
        'row',
        'column',
    ],
    methods: {
        getProductStatusBadge(createElement, value) {
          if (value == '2_runs') {
              return createElement(
                  'span', {
                    class: 'badge',
                    style: { background: 'green' }
                  }, 	"RUNS"
              )
          }
            if (value == '1_paused') {
                return createElement(
                    'span', {
                        class: 'badge',
                        style: { background: 'red' }
                    }, 	"PAUSED"
                )
            }
            if (value == '0_fulfilled') {
                return createElement(
                    'span', {
                        class: 'badge',
                        style: { background: 'blue' }
                    }, 	"FULFILLED"
                )
            }
        }
    },
    render(createElement) {
        if (!this.column.type)
            return createElement(
                'td', this.row[this.column.id]
            );

        if (this.column.type === 'employer_or_campaign')
            if (this.row['employer_id']) {
                return createElement(
                    'td', [
                        createElement(
                            'a', {
                                attrs: {
                                    href: this.url(`admin/employer/${this.row['employer_id']}/budgets`)
                                }
                            }, this.row['employer_name']
                        ),
                    ]);
            }
            else {
                return createElement('td', [this.row['campaign_name']]);
            }

        if (this.column.type === 'money')
            return createElement(
                'td', {
                    class: 'alr'
                }, this.money(this.row[this.column.id])
            );

        if (this.column.type === 'number')
            return createElement(
                'td', {
                    class: 'alr'
                }, this.usNum(this.row[this.column.id])
            );

        if (this.column.type === 'percentage')
            return createElement(
                'td', {
                    class: 'alr'
                }, this.percent(this.row[this.column.id], 0)
            );

        if (this.column.type === 'right')
            return createElement(
                'td', {
                    class: 'alr'
                }, this.row[this.column.id]
            );

        if (this.column.type === 'ratio')
            return createElement(
                'td', {
                    class: 'alr'
                }, this.row[this.column.id]
            );


        if (this.column.type === 'product-status')
            return createElement(
                'td', {
                    }, [this.getProductStatusBadge(createElement, this.row[this.column.id])]
        );

        if (this.column.type === 'fulfillment')
            return this.row['ff_id']
                ? createElement(
                    'td', {
                        class: 'alr'
                    }, [
                        createElement(
                            'a', {
                                attrs: {
                                    href: this.url(`admin/driver-engage/fulfillment/${this.row['ff_id']}`)
                                }
                            }, `${this.row['ff_apps_delivered']}/${this.row['ff_apps_ordered']}`
                        )
                    ])
                : ( this.row['ff_apps_ordered'] ? createElement(
                    'td', {
                        class: 'alr'
                    }, [`${this.row['ff_apps_delivered']}/${this.row['ff_apps_ordered']}`])
                : createElement('td'));

        return createElement(
            'td', ''
        );
    }
}
</script>